<div class="w-full h-full p-4 md:p-6 space-y-6">
    <!-- Unified Header -->
    <div class="mb-4">
        <h1 class="text-2xl md:text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            Prompt Management
        </h1>
        <p class="text-slate-600 dark:text-slate-400 mt-1 text-sm md:text-base">
            Monitor and analyze Prompt.
        </p>
    </div>

    <!-- Tab Navigation for Nested Modules -->
    <div (wheel)="onTabsWheel($event)"
        class="card-bg rounded-2xl p-1 backdrop-blur-xl border border-white/10 flex items-center gap-1 overflow-x-auto custom-scrollbar-hide">
        @for (tab of tabs; track tab.id) {
        <button (click)="activeTab.set(tab.id)"
            [class]="'flex-shrink-0 md:flex-1 px-4 md:px-8 py-3 md:py-4 rounded-xl transition-all duration-500 font-semibold text-sm flex items-center justify-center gap-2 md:gap-3 whitespace-nowrap ' + 
                 (activeTab() === tab.id 
                   ? 'bg-gradient-to-r from-violet-600 to-indigo-600 text-white shadow-xl scale-[1.01] md:scale-[1.02]' 
                   : 'bg-transparent text-slate-500 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-800/50')">
            <app-icon [name]="tab.icon" [size]="18" class="md:w-5 md:h-5" />
            <span class="text-xs md:text-sm">{{ tab.label }}</span>
        </button>
        }
    </div>

    <div class="w-full animate-in fade-in slide-in-from-bottom-6 duration-700">
        @switch (activeTab()) {
        @case ('PROMPTS') { <app-prompt-manager (actionChange)="reloadAuditLogs()" /> }
        @case ('FEATURES') { <app-prompt-features (actionChange)="reloadAuditLogs()" /> }
        @case ('FEATURE_OPTIONS') { <app-prompt-options (actionChange)="reloadAuditLogs()" /> }
        @case ('MAPPINGS') { <app-prompt-mappings (actionChange)="reloadAuditLogs()" /> }
        }
    </div>
    <div class="mt-8">
        <app-audit-log-panel [entityType]="promptEntityTypes" title="Prompt Audit Trails">
        </app-audit-log-panel>
    </div>
</div>